import AnimatedLoadingLabel from './AnimatedLoadingLabel'
export default AnimatedLoadingLabel
